import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchQboItemsAPI } from '@services/WebApiService';
import { canShowPagination } from '@utilities';
import BaseSetting from '@config/BaseSetting';

let currentAbortController = null;

const qboFetchSearchItemsAsync = createAsyncThunk(
  'QboSearchItems/fetchQboSearchItems',
  async (
    { qboRealmId, objectName, pageLink, order, orderBy, top, skip, query, statuses },
    { getState }
  ) => {
    // Cancel the previous request
    if (currentAbortController) {
      currentAbortController.abort();
    }

    // Create a new controller for this request
    currentAbortController = new AbortController();

    const { accessToken } = getState().auth;
    const data = await fetchQboItemsAPI(
      accessToken,
      qboRealmId,
      objectName,
      pageLink,
      {
        top,
        skip,
        order,
        orderBy,
        query,
        intuitDeletedStatus: statuses,
      },
      currentAbortController.signal,
      BaseSetting.searchTimeout
    );
    return data;
  }
);

const { pending, fulfilled, rejected } = qboFetchSearchItemsAsync;

const qboFetchSearchItemsExtraReducers = {
  [pending]: (state) => {
    state.fetchingQboSearchItems = true;
    state.error = null;
  },
  [rejected]: (state, action) => {
    if (action.error?.code) {
      state.error = action.error;
    }

    if (action.error?.code === 'ERR_CANCELED') {
      state.fetchingQboSearchItems = true;
      state.error = null;
    } else {
      state.fetchingQboSearchItems = false;
    }
  },
  [fulfilled]: (state, action) => {
    state.fetchingQboSearchItems = false;

    if (action.payload.error) {
      state.error = action.payload.error;
    } else if (action?.payload?.companyName) {
      const showPagination = canShowPagination(state.QboSearchItems.showPagination, action);

      const {
        companyName,
        backupStatus,
        lastCompletedBackupAt,
        lastBackupAt,
        value,
        nextLink,
        prevLink,
      } = action.payload;

      state.QboSearchItems = {
        companyName,
        backupStatus,
        lastCompletedBackupAt,
        lastBackupAt,
        value,
        nextLink,
        prevLink,
        showPagination,
      };
    }
  },
};

export { qboFetchSearchItemsAsync, qboFetchSearchItemsExtraReducers };
